import React from 'react';
import ReactDOM from 'react-dom';

import 'style/index.css';
import 'style/common.scss';
import 'style/reset.scss';
import 'style/layout.scss';

import App from './App';
import 'lib-flexible'
import reportWebVitals from './reportWebVitals';

console.log(
  'env: ',
  process.env.REACT_APP_MODE,
  process.env.REACT_APP_API_ENDPOINT,
);

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
